import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes, useNavigate } from "react-router-dom";
import AppRoute from './config/app-route.jsx';
import { AuthProvider, useAuth } from './context/AuthContext.js';
import AxiosResponseInterceptor from './config/AxiosResponseInterceptor.js';
import { OrderVialProvider } from './context/OrderVialContext.js'; 
import Swal from 'sweetalert2'; 
// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.css';
import './scss/react.scss';
import 'bootstrap-social/bootstrap-social.css';
import { CommonProvider } from './context/CommonContext.js';


const container = document.getElementById('root');
const root = createRoot(container);

function App() {

	const navigate = useNavigate();
	const { token, logout } = useAuth(); 
	const IDLE_TIMEOUT = parseInt(process.env.REACT_APP_IDLE_TIMEOUT || '600000', 10);


	useEffect(() => {
		if (!token || token === 'null') {
			console.log("Token inválido");
			navigate('/login');
		}
	}, [token, navigate]);

	useEffect(() => {
		if (!token || token === "null") return;

		let timeout;

		const logoutForInactivity = () => {
		Swal.fire({
			title: "Sesión cerrada por inactividad",
			icon: "warning",
			timer: 3000,
			timerProgressBar: true,
			showConfirmButton: false,
		}).then(() => {
			logout();
			navigate("/login");
		});
		};

		const resetTimer = () => {
			if (timeout) clearTimeout(timeout);
			// 30 segundos = 30000 // 1 minuto = 60000 ms //  10 minutos = 600000
			timeout = setTimeout(logoutForInactivity, IDLE_TIMEOUT);
			//timeout = setTimeout(logoutForInactivity, 30000); 
		};

		const events = ["mousemove", "keydown", "mousedown", "touchstart", "wheel", "scroll"];

		events.forEach((event) => window.addEventListener(event, resetTimer));
		resetTimer();

		return () => {
			clearTimeout(timeout);
			events.forEach((event) => window.removeEventListener(event, resetTimer));
		};
	}, [token, logout, navigate]);

	let element = useRoutes(AppRoute);

	return element;
}

root.render(
	<AuthProvider>
		<CommonProvider>
			<OrderVialProvider>
			<BrowserRouter>
				<App />
				<AxiosResponseInterceptor />
			</BrowserRouter>
			</OrderVialProvider>
		</CommonProvider>
	</AuthProvider>
);
